<template>
<div class="box-span6 paddingr10">
	<slot></slot>
</div>
</template>

<script>
export default {
};
</script>

<style lang="scss">

</style>